<div class="app-header" [ngClass]="{'checked': checked, 'unchecked' : !checked, 'mobile': mobile}">
    <div class="app-header-left">
        <div class="docker" (click)="showHide()">
            <label for="docker">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-panel-left docker-icon">
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M9 3v18"></path>
                </svg>
            </label>

        </div>
        <div class="marina">
            <p-dropdown [options]="marinas" optionLabel="tradeName" class="primeDropdown" [(ngModel)]="newSelectedMarina"
                (onChange)="selectMarina()" *ngIf="marinas.length > 1" appendTo="body">
            </p-dropdown>
            <div *ngIf="marinas.length <= 1" class="font-small">{{getMarinaName()}}</div>
        </div>
    </div>

    <div *ngIf="showFranquiaBoats" class="franquia-badge"
        [ngClass]="{ 'franquia-badge--warning': isFranquiaWarning, 'franquia-badge--danger': !isFranquiaWarning }">

        <i class="pi" [ngClass]="isFranquiaWarning ? 'pi-exclamation-triangle' : 'pi-times-circle'"></i>

        <div class="franquia-badge-content">
            <ng-container *ngIf="isFranquiaWarning">
                <span class="franquia-badge-main">{{ qtdActiveBoats }} de {{ qtdMaxBoat }} embarcações usadas</span>
                <div class="franquia-badge-bar">
                    <div class="franquia-badge-bar-fill" [ngStyle]="{ 'width': franquiaBarWidth + '%' }"></div>
                </div>
                <span class="franquia-badge-sub">Você está próximo do limite.</span>
            </ng-container>

            <ng-container *ngIf="isFranquiaAtLimit">
                <span class="franquia-badge-main">Limite de {{ qtdMaxBoat }} embarcações atingido.</span>
                <span class="franquia-badge-sub">Faça upgrade do seu plano.</span>
            </ng-container>

            <ng-container *ngIf="isFranquiaExceeded">
                <span class="franquia-badge-main">{{ qtdActiveBoats }} de {{ qtdMaxBoat }} embarcações — {{ franquiaExcedentes }} excedentes.</span>
                <span class="franquia-badge-sub">Faça upgrade do seu plano.</span>
            </ng-container>
        </div>

        <button *ngIf="!isFranquiaWarning" class="franquia-badge-support" (click)="openWhatsappSupport()">
            <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon> Contatar suporte
        </button>
    </div>

    <div class="app-header-right">

        <app-header-search></app-header-search>
        <span class="user-name">
            {{ getLoggedUser() }}
        </span>
        <button
            type="button"
            class="support-button"
            (click)="openSupportPortal()"
            pTooltip="Portal de Suporte"
            tooltipPosition="bottom"
            aria-label="Abrir portal de suporte em nova aba">
            <fa-icon [icon]="['fas', 'headset']"></fa-icon>
        </button>
        <app-header-button-new-navigation></app-header-button-new-navigation>
        <app-header-button-notification></app-header-button-notification>
        <app-header-button-user-config></app-header-button-user-config>
    </div>
</div>
